import { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Form, Input, Space, Table, message, Typography, Drawer } from 'antd';
import { getUserListApi, saveUserApi } from '@services/Invitation/InvitationUser';
import { getInvitationOneApi } from '@services/Invitation/Invitation';
import WorkExperiences from '@/components/common/WorkExperiences';
import ExpertInfoCard from '@/components/common/ExpertInfoCard';
import './AddGuest.less';
import { TABLE_PAGE_SIZE_OPTIONS } from '@/utils/property';

const { Text } = Typography;

const AddGuest = ({ closeAddUserDrawer, visibleAddUserDrawer, setVisibleAddUserDrawer, onResetGuest }) => {
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [inPageSize, setInPageSize] = useState(10);
    const [inPage, setInPage] = useState(1);
    const [inTotal, setInTotal] = useState(0);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const isSearchRef = useRef(null);
    const [expertForm] = Form.useForm();
    const [inForm] = Form.useForm();
    const params = useParams();
    const [filObj, setFilObj] = useState({ name: '' });
    const [btnLoad, setBtnLoad] = useState(false);

    const [invitationOne, setInvitationOne] = useState({});

    const guestSelectionTableColumns = [
        {
            title: '基本信息',
            dataIndex: 'memUsername',
            width: 200,
            render: (_, record) => <ExpertInfoCard expert={record} />,
        },
        {
            title: '单位任职',
            dataIndex: 'ssoMemberWorkExperiencesEntities',
            width: 200,
            render: (_, record) => <WorkExperiences workExperiences={record.ssoMemberWorkExperiencesEntities} />,
        },
        {
            title: '本会议邀请方',
            name: 'organisations',
            width: 200,
            render: (_, record) => {
                const organisations = record?.guestsEntity?.organisations;
                return organisations && !!organisations.length ? organisations.map(item => item.name).join('、') : <Text type="secondary">&ndash;</Text>;
            },
        },
        {
            title: '状态',
            dataIndex: 'selected',
            width: 100,
            render: (_, record) => (record.selected === 1 ? <Text type="success">已邀请</Text> : record.selected === 0 ? <Text type="secondary">未邀请</Text> : <Text type="secondary">&ndash;</Text>),
        },
    ];

    const guestSelectedTableColumns = [
        {
            title: '基本信息',
            dataIndex: 'memUsername',
            width: 200,
            render: (_, record) => <ExpertInfoCard expert={record} />,
        },
        {
            title: '单位任职',
            dataIndex: 'ssoMemberWorkExperiencesEntities',
            width: 200,
            render: (_, record) => <WorkExperiences workExperiences={record.ssoMemberWorkExperiencesEntities} />,
        },
        {
            title: '本会议邀请方',
            name: 'organisations',
            width: 200,
            render: (_, record) => {
                const organisations = record?.guestsEntity?.organisations;

                return organisations && !!organisations.length ? organisations.map(item => item.name).join('、') : <Text type="secondary">&ndash;</Text>;
            },
        },
        {
            title: '状态',
            dataIndex: 'selected',
            width: 100,
            render: (_, record) => (record.selected === 1 ? <Text type="success">已邀请</Text> : record.selected === 0 ? <Text type="secondary">未邀请</Text> : <Text type="secondary">&ndash;</Text>),
        },
        {
            title: '操作',
            width: 100,
            fixed: 'right',
            render: (_, record) => (
                <Button type="link" size="small" icon={<i className="bi bi-x-circle-fill"></i>} onClick={() => removeGuest(record)}>
                    移除
                </Button>
            ),
        },
    ];

    const [guestsToSelect, setGuestsToSelect] = useState([]);
    const [guestsSelected, setGuestsSelected] = useState([]);
    const [guestsFilter, setGuestsFilter] = useState([]);

    // 添加用户
    const addGuests = () => {
        setBtnLoad(true);
        const expertIds = guestsSelected.map(item => item.id);
        const params = {
            expertIds: expertIds,
            invitationGroupId: invitationOne.groupId,
            invitationId: invitationOne.id,
        };
        saveUserApi(params).then(res => {
            setBtnLoad(false);
            if (res.status_code === 200) {
                message.success('添加成功');
                setVisibleAddUserDrawer(false);
                onResetGuest('change');
            }
        });
        // TODO
    };

    // 移除已选用户
    const removeGuest = record => {
        const newSelected = guestsSelected.filter(item => item.id !== record.id);
        const newSelectedIds = newSelected.map(item => item.id);

        setGuestsSelected(newSelected);
        setGuestsFilter(newSelected);
        setSelected(newSelectedIds);
        setInTotal(newSelected.length);
    };

    const guestToSelectSelection = {
        selectedRowKeys: selected,
        onSelect: (record, select) => {
            if (select) {
                // 选中后立即添加到已选用户
                const isExist = guestsSelected.some(item => item.id === record.id);
                if (!isExist) {
                    const newGuestsSelected = [...guestsSelected, record];
                    setGuestsSelected(newGuestsSelected);
                    setGuestsFilter(newGuestsSelected);
                    setInTotal(newGuestsSelected.length);
                }

                const originalArray = [...selected, record.id];
                const uniqueArray = Array.from(new Set(originalArray));
                setSelected([...uniqueArray]);
            } else {
                // 取消选中时从已选用户中移除
                const newGuestsSelected = guestsSelected.filter(item => item.id !== record.id);
                setGuestsSelected(newGuestsSelected);
                setGuestsFilter(newGuestsSelected);
                setInTotal(newGuestsSelected.length);

                const re = selected.filter(it => it !== record.id);
                setSelected([...re]);
            }
        },
        onSelectAll: (select, selectedRows, changeRows) => {
            if (select) {
                // 全选时添加当前页所有用户到已选用户
                const newGuestsSelected = [...guestsSelected];

                // 使用 selectedRows 参数，它包含当前页所有被选中的行
                selectedRows.forEach(row => {
                    const isExist = newGuestsSelected.some(item => item.id === row.id);
                    if (!isExist) {
                        newGuestsSelected.push(row);
                    }
                });

                setGuestsSelected(newGuestsSelected);
                setGuestsFilter(newGuestsSelected);
                setInTotal(newGuestsSelected.length);

                // 更新选中的 ID 列表
                const selectedIds = selectedRows.map(i => i.id);
                const originalArray = [...selected, ...selectedIds];
                const uniqueArray = Array.from(new Set(originalArray));
                setSelected([...uniqueArray]);
            } else {
                // 全不选时从已选用户中移除当前页的所有用户
                const changeIds = changeRows.map(i => i.id);
                const newGuestsSelected = guestsSelected.filter(item => !changeIds.includes(item.id));
                setGuestsSelected(newGuestsSelected);
                setGuestsFilter(newGuestsSelected);
                setInTotal(newGuestsSelected.length);

                // 从选中列表中移除当前页的 ID
                const newSelectedIds = selected.filter(id => !changeIds.includes(id));
                setSelected(newSelectedIds);
            }
        },
    };

    const getExpertlist = useCallback(
        async (page, pageSize, name) => {
            setLoading(true);
            isSearchRef.current = false;
            const obj = {
                page,
                limit: pageSize,
                applicationItemId: invitationOne.invitationGroup?.applicationItemId,
                applicationType: invitationOne.invitationGroup?.applicationType,
                name,
                invitationId: Number(params.id || 0),
            };

            const res = await getUserListApi(obj);
            if (res.status_code === 200) {
                setLoading(false);
                setGuestsToSelect(res.data.list);
                setTotal(res.data.totalCount);
            }
        },
        [invitationOne.invitationGroup?.applicationItemId, invitationOne.invitationGroup?.applicationType, params.id],
    );

    const onChangePage = (page, pageSize) => {
        setPage(page);
        setPageSize(pageSize);
    };

    const onChangeInPage = (page, pageSize) => {
        setInPage(page);
        setInPageSize(pageSize);
    };

    const expertFormFinish = res => {
        isSearchRef.current = true;
        setFilObj({
            name: expertForm.getFieldValue('name') || '',
        });
        if (expertForm.getFieldValue('name') === undefined || expertForm.getFieldValue('name') === '') {
            setPage(1);
        }
        expertForm.resetFields();
    };

    const filterIn = () => {
        const old = [...guestsFilter];
        if (inForm.getFieldValue('name') !== undefined && inForm.getFieldValue('name') !== '') {
            const fil = guestsFilter.filter(item => {
                return item?.memUsername.indexOf(inForm.getFieldValue('name')) > -1;
            });
            setGuestsSelected([...fil]);
        } else {
            setGuestsSelected([...old]);
        }
    };

    useEffect(() => {
        getInvitationOneApi({ id: params?.id || 0 }).then(res => {
            if (res.status_code === 200) {
                setInvitationOne(res.data);
            }
        });
    }, [params?.id]);

    useEffect(() => {
        const { name } = filObj;
        if (visibleAddUserDrawer && invitationOne.invitationGroup) {
            if (isSearchRef.current === true) {
                getExpertlist(1, pageSize, name);
            } else {
                getExpertlist(page, pageSize, name);
            }
        }
    }, [page, pageSize, filObj, visibleAddUserDrawer, invitationOne.invitationGroup, getExpertlist]);

    useEffect(() => {
        if (!visibleAddUserDrawer) {
            setGuestsSelected([]);
            setGuestsFilter([]);
            setSelected([]);
            setInTotal(0);
        }
    }, [visibleAddUserDrawer]);

    return (
        <div>
            <Drawer
                closable={{ placement: 'end' }}
                title="添加邀请用户"
                placement="bottom"
                size="100%"
                destroyOnHidden
                open={visibleAddUserDrawer}
                onClose={closeAddUserDrawer}
                footer={
                    <div className="custom-drawer-footer" style={{ textAlign: 'right' }}>
                        <Space>
                            <Button onClick={closeAddUserDrawer}>取消</Button>
                            <Button type="primary" loading={btnLoad} onClick={addGuests}>
                                确定
                            </Button>
                        </Space>
                    </div>
                }
            >
                <div className="guest-selection-area">
                    <div className="guests-to-select box-hover-shadow">
                        <div className="guest-selection-title">
                            <i className="bi bi-caret-down-fill"></i> 可选用户
                        </div>
                        <div className="guest-selection-filter">
                            <Form layout="inline" size="small" form={expertForm}>
                                <Form.Item label="姓名" name="name">
                                    <Input placeholder="用户姓名" />
                                </Form.Item>
                                <Form.Item>
                                    <Button onClick={expertFormFinish}>
                                        <i className="bi bi-search"></i> 检索
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                        <Table
                            size="small"
                            columns={guestSelectionTableColumns}
                            dataSource={guestsToSelect}
                            rowKey={row => row.id}
                            rowSelection={{ type: 'checkbox', ...guestToSelectSelection }}
                            loading={loading}
                            pagination={{
                                total: total,
                                showTotal: () => `共${total}条`,
                                current: page,
                                pageSize: pageSize,
                                pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
                                onChange: onChangePage,
                                showQuickJumper: true,
                                showSizeChanger: true,
                            }}
                            onRow={record => ({
                                onClick: () => {
                                    const isSelected = selected.includes(record.id);
                                    guestToSelectSelection.onSelect(record, !isSelected);
                                },
                                style: { cursor: 'pointer' },
                            })}
                        />
                    </div>

                    <div className="guests-selected box-hover-shadow">
                        <div className="guest-selection-title">
                            <i className="bi bi-caret-down-fill"></i> 已选用户
                        </div>
                        <div className="guest-selection-filter">
                            <Form layout="inline" size="small" form={inForm}>
                                <Form.Item label="姓名" name="name">
                                    <Input placeholder="用户姓名" />
                                </Form.Item>
                                <Form.Item>
                                    <Button onClick={filterIn}>
                                        <i className="bi bi-funnel"></i> 过滤
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                        <Table
                            size="small"
                            columns={guestSelectedTableColumns}
                            dataSource={guestsSelected}
                            rowKey={rows => rows.id}
                            pagination={{
                                showTotal: () => `共${inTotal}条`,
                                current: inPage,
                                pageSize: inPageSize,
                                pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
                                onChange: onChangeInPage,
                                showQuickJumper: true,
                                showSizeChanger: true,
                            }}
                        />
                    </div>
                </div>
            </Drawer>
        </div>
    );
};

export default AddGuest;
